export interface Claim {
  type: string
  value: string
}

export interface UserToken {
  id: string
  email: string
  nomeUsuario: string | null
  supervisorEmail: string | null
  supervisorNome: string | null
  supervisorBackofficeId: string | null
  clienteIntegradoorId: string | null
  phoneNumber: string | null
  foto: string | null
  countryCode: string | null
  perfil: string
  usuarioBackofficeId: string
  claims: Claim[]
  usa2FA: boolean
}

export interface LoginResponse {
  accessToken: string | null
  refreshToken: string | null
  expiresIn: number
  userToken: UserToken
  isPasswordStillDefault: boolean
  requer2FA: boolean
  desafio2FA: string | null
}

export type LoginAutenticado = LoginResponse & { accessToken: string; refreshToken: string }

export const loginAutenticado = (login: LoginResponse): login is LoginAutenticado =>
  Boolean(login.accessToken && login.refreshToken)

export interface LoginPayload {
  email: string
  password: string
}

export interface EnviarCodigo2FAPayload {
  desafio: string
}

export interface ValidarCodigo2FAPayload {
  desafio: string
  codigo: string
}

export interface EsqueciSenhaResponse {
  idUsuario: string
  phoneNumber: string | null
  countryCode: string | null
  tipo2FA: number | null
}

export interface AlterarSenhaPayload {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}
